module.exports = __webpack_public_path__ + "img/42-GPR.7d715a2.png";